import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { User } from './models/user.model';
import { NotificationService } from './services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  private router = inject(Router);
  private notification = inject(NotificationService);

  canActivate(route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): boolean | UrlTree {
    let user: User | null = null;
    try {
      const stored = localStorage.getItem('user');
      user = stored ? JSON.parse(stored) : null;
    } catch {
      user = null;
    }

    if (!user || !user.isLogin) {
      this.notification.warning('You are not allowed to view this page. You are redirected to the home page.');
      this.router.navigate(["/"], { queryParams: { retUrl: route.url } });
      return false;
    }

    return true;
  }
}
